import { FC } from 'react';

import { PolicyPage } from 'Pages';

export const PolicyScreen: FC = () => {
  return <PolicyPage />;
};
